import { readerLanguage } from "./blog-urls";
import { sdk } from "@/api/sdk";
import { BlogAudience, type AppLanguage } from "@complete-athlete/enums";

/** Posts per page, on the server's first page and every "Show more" after it. */
export const BLOG_PAGE_SIZE = 12;

/** What a page of the blog lists: everything, one shelf, or one author's posts. */
export type BlogListFilter = { category?: string; author?: string; lang?: AppLanguage };

/** The request for one page of a blog list, the same on the server and for every "Show more". */
export const blogListRequest = (filter: BlogListFilter, offset = 0) =>
  sdk.blog.posts.$get.setQueryParams({
    audience: BlogAudience.COACH,
    locale: readerLanguage(),
    limit: String(BLOG_PAGE_SIZE),
    offset: String(offset),
    ...filter,
  });
